import { DaoModel } from '@dynameat/models';

export class ProductMasterModelLanguage extends DaoModel {
  constructor(modelLanguage, commercialName, commercialDescription, longCommercialDescription) {
    super();
    this.modelLanguage = modelLanguage;
    this.commercialName = commercialName;
    this.commercialDescription = commercialDescription;
    this.longCommercialDescription = longCommercialDescription;
  }

  static toInstance(props = {}) {
    return new ProductMasterModelLanguage(props.model_language, props.commercial_name, props.commercial_description,
      props.long_commercial_description);
  }

  serialize() {
    return {
      model_language: this.modelLanguage,
      commercial_name: this.commercialName,
      commercial_description: this.commercialDescription,
      long_commercial_description: this.longCommercialDescription,
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('model_language', this.modelLanguage);
    formData.append('commercial_name', this.commercialName);
    formData.append('commercial_description', this.commercialDescription);
    formData.append('long_commercial_description', this.longCommercialDescription);
    return formData;
  }
}
